export enum Endpoint {
  // general endpoints
  GETUSERDETAILS = 'api/GetUserDetails',
  GETREDEEMREWARDSLOG = 'api/GetRedeemRewards_Log',
  ISREWARDREDEEMED = 'api/IsRewardRedeemed',
  REWARDUNUSEDDELETERESERVATION = 'api/Reward_UnusedDeleteReservation',
  MAKEREWARDRESERVATION = 'api/MakeReward_Reservation',
  DELETEREWARD = 'api/Delete_Reward',
  REDEEMREWARD = 'api/Redeem_Reward',
  GETREWARDS = 'api/GetRewards',
  MODIFYREWARD = 'api/Modify_Reward',
  UPDATESTUDENTROSTER = 'api/UpdateStudentRoster',
  GETSTUDENTROSTERLOG = 'api/GetStudentRosterLog',
  GETSTUDENTROSTER = 'api/GetStudentRoster',
  GETALLNOTE_TAGS = 'api/getAllNote_Tags',
  GETINITIALREGISTRATIONS_TYPES = 'api/GetInitialsRegistrations_Types',
  GETSICKEVENT4STUDENT = 'api/GetSickEvent4Student',
  GETEVENTINFO = 'api/GetEventInfo',
  CREATELEAVEEVENT = 'api/CreateLeaveEvent',
  DELETESICKEVENT4STUDENT = 'api/DeleteSickEvent4Student',
  DELETESTUDENTNOTE = 'api/DeleteStudentNote',
  GET_TOKEN = 'api/get_token',
  GETACCESSTOKEN = 'api/getAccessToken',
  SEARCH = 'api/search',
  GET_CLIENTDATA = 'api/getClientData',
  GET_CLIENTTUTORIAL = 'api/getClientTutorial',
  SET_CLIENTTUTORIAL = 'api/setClientTutorial',
  GET_ALLCLIENTSETTING = 'api/getAllClientSetting',
  GET_ALLCLIENTSETTINGS = 'api/GetAllClientSettings',
  GET_USERSETTING = 'api/getUserSetting',
  SET_USERSETTING = 'api/setUserSetting',
  CHECK_CHECKINCODE = 'api/Check_CheckInCode',
  GETUSERINFO = 'api/getUserInfo',
  GETDEPARTMENTSETTINGS = 'api/getDepartmentSettings',
  GETLEAVEINFO = 'api/GetLeaveInfo',
  REGICHECKFORCHANGES = 'api/Regi_CheckForChanges',
  GETSTUDENTSINFO = 'api/getStudentsInfo',
  // registration endpoints
  REGI_GETCOURSESBYTEACHERNAME = 'api/Regi_GetCoursesByTeacherName',
  GETNOTECOUNTS4STUDENT = 'api/GetNoteCounts4Student',
  REGI_GETSTUDENTNOTE = 'api/Regi_GetStudentNote',
  REGI_SETSTUDENTNOTE = 'api/Regi_SetStudentNote',
  REGI_GETSTUDENTS4ALLDAYVIEW = 'api/Regi_GetStudents4AllDayView',
  REGI_MARKSTUDENTS4ALLDAYVIEW = 'api/Regi_MarkStudents4AllDayView',
  REGI_GETCOURSESBYSTUDENTNAME = 'api/Regi_GetCoursesByStudentName',
  REGI_GETCOURSESBYCOURSENAME = 'api/Regi_GetCoursesByCourseName',
  REGI_GETCOURSENAMEBYTIMEBLOCKID = 'api/Regi_GetCourseNameByTimeblockID',
  REGI_GETSTUDENTSBYTIMEBLOCKID = 'api/Regi_GetStudentsByTimeBlockId',
  REGI_MARKSTUDENTSTATUSBYTIMEBLOCKIDANDSTUDENTID = 'api/Regi_MarkStudentStatusByTimeBlockIDAndStudentId',
  REGI_MARKALLSTUDENTSSTATUSBYTIMEBLOCKID = 'api/Regi_MarkAllStudentsStatusByTimeBlockID',
  REGI_MARKTIMEBLOCKID = 'api/Regi_MarkTimeBlockId',
  REGI_GETREGISTRATIONLOG = 'api/Regi_GetRegistrationLog',
  REGI_GETTIMEBLOCKSDATESBYCOURSEID = 'api/Regi_GetTimeBlocksDatesByCourseID',
  REGI_GETTIMEBLOCKSDATESBYTEACHERID = 'api/Regi_GetTimeBlocksDatesByTeacherID',
  REGI_GETTIMEBLOCKSDATESBYSTUDENTID = 'api/Regi_GetTimeblocksDatesByStudentID',
  REGI_GETREGISTRATIONOVERVIEW = 'api/Regi_GetRegistrationOverView',
  STUDENT_STAT_GETABSENCELOGSTUDENTDATE = 'api/Student_Stat_GetAbsenceLogStudentDate',

  // teacherpage endpoints
  TEACHER_STAT_COURSEPERCENTAGEOVERTIME = 'api/Teacher_Stat_CoursePercentageOverTime',
  TEACHER_STAT_GETSTUDENTSABSENCE = 'api/Teacher_Stat_GetStudentsAbsence',
  TEACHER_STAT_GETUNMARKEDLESSONS = 'api/Teacher_Stat_GetUnmarkedLessons',
  TEACHER_STAT_GETCOURSEPERCENTAGE = 'api/Teacher_Stat_GetCoursePercentage',

  // studentpage endpoints
  STUDENT_STAT_GETTOTALPERCENTAGEDAY = 'api/Student_Stat_GetTotalPercentageDay',
  STUDENT_STAT_GETTOTALPERCENTAGE = 'api/Student_Stat_GetTotalPercentage',
  STUDENT_STAT_GETCOURSEDETAILS = 'api/Student_Stat_GetCourseDetails',
  STUDENT_STAT_GETCOURSEPERCENTAGE = 'api/Student_Stat_GetCoursePercentage',
  STUDENT_STAT_GETABSENCETYPESPERCOURSE = 'api/Student_Stat_GetAbsenceTypesPerCourse',
  STUDENT_STAT_GETREGISTRATIONS = 'api/Student_Stat_GetRegistrations',  
  STUDENT_STAT_GETCOINS = 'api/Student_Stat_GetCoins',
  STUDENT_STAT_GETHEATMAPDETAILS = 'api/Student_Stat_GetHeatMapDetails',
  STUDENT_STAT_GETREWARDS = 'api/Student_Stat_GetRewards',
  GETTRANSACTIONLOG_COINS = 'api/GetTransactionLog_Coins',
  GETTRANSACTIONLOG_STATS = 'api/GetTransactionLog_Stats',
  GETTRANSACTIONLOG_COINSALLSTUDENTS = 'api/GetTransactionLog_CoinsAllStudents',
  MAKETRANSACTION_COINS = 'api/MakeTransaction_Coins',
  STUDENT_STAT_GETALLCOURSESCLASSIDS = 'api/Student_Stat_GetAllCoursesClassIDs',
  STUDENT_STAT_COURSECHARTOVERTIME = 'api/Student_Stat_CourseChartOverTime',
  GETSTREAK4STUDENT = 'api/GetStreak4Student',
  UPDATEBADGES4STUDENT = 'api/UpdateBadges4Student',
  CALCULATEBADGES4STUDENT = 'api/CalculateBadges4Student',
  GETBADGES4STUDENT_Splash = 'api/GetBadges4Student_Splash',
  GETALLBADGES4STUDENT = 'api/GetAllBadges4Student',
  STUDENT_CHECKINOUT = 'api/Student_CheckInOut',
  STUDENT_GETCHECKINOUT = 'api/Student_GetCheckInOut',
  GETNOTE_TAGS = 'api/GetNote_Tags',
  GETALLSTUDENTNOTES = 'api/GetAllStudentNotes',

  // adminpage endpoints
  ADM_COURSEPERCENTAGEOVERTIME = 'api/ADM_CoursePercentageOverTime',
  ADM_STUDENTSPERCLASS_ID = 'api/ADM_StudentsPerClass_ID',
  ADM_COURSEINFOCLASSID = 'api/ADM_CourseInfoClassId',
  EXPORT_COURSESTATISTIC = 'api/Export_CourseStatistic',
  EXPORT_STUDENT = 'api/Export_Student',
  ADM_COURSESTAT2EXCEL = 'api/ADM_CourseStat2Excel',
  ADM_SUBJECTONCOURSESTAT2EXCEL = 'api/ADM_SubjectOnCourseStat2Excel',
  
  //Bot endpoints
  GET_TEAMSBOT_MEETING_PRESENCE = 'api/Get_TeamsBot_Meeting_Presence',
  GET_TEAMSBOT_PRESENCE = 'api/TeamsBot_Get_Presence',
  SET_TEAMSBOT_LANGUAGE = 'api/setTeamsBotLanguage',

  // statistics endpoints
  STATS_GETABSENCEBYSTUDENTIDANDORTIMEBLOCKID = 'api/Stats_GetAbsenceByStudentIDAndOrTimeBlockID',
  GETUSERCLASSFAVORITES = 'api/GetUser_Class_Favorites',
  GETUSERSTUDENTFAVORITES = 'api/GetUser_Student_Favorites',
  GETUSERTEACHERFAVORITES = 'api/GetUser_Teacher_Favorites',
  SETUSERFAVORITES = 'api/SetUser_Favorites',
  GETALLLESSONDAYS4STUDENT = 'api/GetAllLessonDays4Student',

  //Other endpoints
  GETDNICASEWORKERCLIENTS = 'api/getDNICaseworkerClients',
  GETCASEWORKERSTUDENTS = 'api/GetCaseWorker_Students',
  SETLUDUSCASEWORKEREMAILREPORT = 'api/SetLUDUS_CaseworkerEmailReport',
  GETLUDUSCASEWORKERREPORTSRECEPIENTS = 'api/GetLUDUS_CaseworkerReportsRecepients',
  GETREPOTDATA_LUDUS = 'api/GetReportData_LUDUS',

  //Written endpoints
  GETASSIGNMENTBYTYPE = 'api/GetAssignmentByType',
  GETASSIGNMENT = 'api/GetAssignment',
  GETASSIGNMENTINFO = 'api/GetAssignmentInfo',
  WRITTENSEARCH = 'api/WrittenSearch',
  SETMANUELASSIGNMENTABSENCE = 'api/SetManuelAssignmentAbsence',

  //Merit endpoints 
  LISTCOURSESFORSTUDENT = 'api/ListCoursesForStudent',
  UPDATESTUDENTENTRY = 'api/UpdateStudentEntry',
  GENERATEMERITLIST = 'api/GenerateMeritList', 
  GETMERITSTUDENTSBYTIMEBLOCKS = 'api/GetMeritStudentByTimeBlocks', 
  CALCULATEMERITSTUDENTONCOURSE = 'api/CalculateMeritStudentOnCourse',
  GETTIMEBLOCKSBYSTUDENTIDANDDATE = 'api/GetTimeBlocksByStudentIdAndDate',
  COUNTACTIVEREGISTRATIONS = 'api/CountActiveRegistrations',
  DELETEACTIVEREGISTRAIONS = 'api/DeleteActiveRegistrations',
  
  //Pause endpoints
  GETPAUSESTUDENTBYTIMEBLOCKS = 'api/GetPauseStudentByTimeBlocks',
  CHECK4NOTFULLDAYS = 'api/Check4NotFulldays',
  GETPAUSE4TIMEBLOCK = 'api/GetPause4Timeblock',
  GETPAUSE4TIMEBLOCKSALLDAYVIEW = 'api/GetPause4TimeblocksAlldayView',
  GETPAUSE4STUDENTS = 'api/GetPause4Students',
  GETPAUSE4STUDENTPERCLASS = 'api/GetPause4StudentPerClass',
  GETPAUSE4CLASS = 'api/GetPause4Class',
  GETPAUSE4HEATMAP = 'api/GetPause4HeatMap',

  //WONDE
  WONDEGETALLTAGS = 'api/WondeGetAllTags',

  //MitId
  CHECKMITIDLOGIN = 'api/CheckMitidLogin',
  GUARDIANGETSTUDENTS = 'api/guardian_getstudents',
  GETSTUDENTABSENCEREGISTRATIONS = 'api/GetStudentAbsenceRegistrations',
    
  //Guardian
  CREATEABSENCEREQUEST = 'api/CreateAbsenceRequest' ,
  GETABSENCEREQUESTS4PARENT = 'api/GetAbsenceRequests4Parent',
  UPDATEABSENCEREQEUST = 'api/UpdateAbsenceRequest',
  GETABSENCEREQUESTS4APPROVAL =  'api/GetAbsenceRequests4Approval',
  APPROVEDENYREQUEST = 'api/ApproveDenyRequest',
  GETATTCOUNTER4USER = 'api/GetAttCounter4User',
  DELETEABSENCEREQUEST = 'api/DeleteAbsenceRequest',
  GETGUARDIANS = 'api/GetGuardians',
  DELETEGUARDIAN4STUDENT = 'api/DeleteGuardian4Student',
  SETGUARDIAN4STUDENT = 'api/SetGuardian4Student',
  CHECKFORSTUDENTUPDATE = 'api/CheckForStudentUpdate',

  //DashBoard
  COUNTABSENCETAGS = 'api/CountAbsenceTags',
  COUNTABSENCETYPES = 'api/CountAbsenceTypes',
  GETNOTESFORDASH = 'api/GetNotesForDash',
  GETCOURSES = 'api/GetCourses',
  GETSTUDENTS = 'api/GetStudents',
  GETALLREGISTRATIONS = 'api/GetAllRegistrations',
  GETTREND = 'api/GetTrend',
  GETSICKEVENT4ALLSTUDENTS = 'api/GetSickEvent4AllStudents',
  GETCOURSEABSENCEFORSTUDENT = 'api/GetCourseAbsenceForStudent',
  GETCOURSELIST = 'api/GetCourseList',
  GETSUBJECTLIST = 'api/GetSubjectList',
  GETSTUDENTABSENCEONCOURSE = 'api/GetStudentAbsenceOnCourse',
  GETSTUDENTABSENCEONCOURSEANDSUBJECT = 'api/GetStudentAbsenceOnCourseAndSubject',
  GETFILTERS4USER = 'api/GetFilters4user',
  SETFILTER4USER = 'api/SetFilter4User',
  CHECKIFKOHORTEXISTS = 'api/CheckIfKohortExists',
  LISTKOHORTS = 'api/ListKohorts',
  KOHORTGETPERCENTAGES = 'api/KohortGetPercentages',
  GETSTUDENTABSENCEWITHPREDICTIONS = 'api/GetStudentAbsenceWithPredictions',

  GETREPORTDATA_KILKENNY = 'api/GetReportData_KilKenny',
  CREATEEVENTINQUEUE = 'api/CreateEventInQueue',

  UPDATETEACHERNAME = 'api/UpdateTeacherName',
  MERGELOGIN = 'api/MergeLogin',
  STUDENT_STAT_GETDAYVIEWREGISTRATIONS = 'api/Student_Stat_GetDayviewRegistrations',

  GETABSENCEREGISTRATIONS4DAY = 'api/GetAbsenceRegistrations4Day',

  POSTREQUEST = 'api/postRequest',

  GETABSENCESPRDATE = 'api/GetAbsencePrDate',
  GETCURRENTLOCALDATETIME = 'api/GetCurrentLocalDateTime',
  GETALLBADGES = 'api/GetAllBadges',
  SETBADGESACTIVE = 'api/SetBadgesActive',

  GETCHECKINCODEV2 = 'api/Get_CheckInCodeV2',
  GETCLIENTAPPSETTINGS = 'api/getClient_APP_Settings',

  GETMISSINGREGISTRATIONS = 'api/GetMissingRegistrations',
  GETMISSINGREGISTRATIONSBYTEACHER = 'api/GetMissingRegistrationsByTeacher',
}

export default Endpoint;
